import type { PipeTransform } from "@angular/core";
import { inject, Pipe } from "@angular/core";

import { ItemsLanguages } from "../../app/api/packbo/models/items-languages";
import { DirectusTranslationService } from "../i18n/directus-translation.service";

@Pipe({
    name: "getTranslation",
    standalone: true,
    pure: false
})
export class DirectusTranslationPipe implements PipeTransform {
    private readonly directusTranslationService = inject(DirectusTranslationService);

    transform<T extends { languages_code?: string | ItemsLanguages | null }>(
        translations: (T | number)[] | null | undefined,
        property: keyof T
    ): string {
        if (!translations || !Array.isArray(translations) || translations.length === 0) {
            return "";
        }

        return this.directusTranslationService.getTranslation(translations, property);
    }
}
